import { useCurrentFiscalYear } from '@/features/search/_hooks/get-current-fiscal-year';
import type { PropsWithChildren } from 'react';

export const InitializeProvider = ({ children }: PropsWithChildren) => {
  const { isPending } = useCurrentFiscalYear();

  if (isPending) {
    return null;
  }
  return <>{children}</>;
};
